'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Prepare attributes to be parsed
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _Parser = require('./Parser');

var _Parser2 = _interopRequireDefault(_Parser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Builder = function () {
  function Builder(model) {
    _classCallCheck(this, Builder);

    this.model = model;
    this.includes = [];
    this.appends = [];
    this.sorts = [];
    this.pageValue = null;
    this.limitValue = null;
    this.payload = null;

    this.fields = {
      fields: {}
    };
    this.filters = {
      filter: {}
    };

    this.parser = new _Parser2.default(this);
  }

  // query string parsed 


  _createClass(Builder, [{
    key: 'query',
    value: function query() {
      return this.parser.query();
    }

    /**
     * Query builder
     */

  }, {
    key: 'include',
    value: function include() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      this.includes = args;

      return this;
    }
  }, {
    key: 'append',
    value: function append() {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      this.appends = args;

      return this;
    }
  }, {
    key: 'select',
    value: function select() {
      var _this = this;

      for (var _len3 = arguments.length, fields = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        fields[_key3] = arguments[_key3];
      }

      if (fields.length === 0) {
        throw new Error('You must specify the fields on select() method.');
      }

      // single entity .select(['age', 'firstname'])
      if (fields[0].constructor === String || fields[0].constructor === Array) {
        this.fields.fields[this.model.resource()] = fields.join(',');
      }

      // related entities .select({ posts: ['title', 'content'], user: ['age', 'firstname']} )
      if (fields[0].constructor === Object) {
        Object.entries(fields[0]).forEach(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              key = _ref2[0],
              value = _ref2[1];

          _this.fields.fields[key] = value.join(',');
        });
      }

      return this;
    }
  }, {
    key: 'where',
    value: function where(key, value) {
      if (key === undefined || value === undefined) throw new Error('The KEY and VALUE are required on where() method.');

      if (Array.isArray(value) || value instanceof Object) throw new Error('The VALUE must be primitive on where() method.');

      this.filters.filter[key] = value;

      return this;
    }
  }, {
    key: 'whereIn',
    value: function whereIn(key, array) {
      if (!Array.isArray(array)) throw new Error('The second argument on whereIn() method must be an array.');

      this.filters.filter[key] = array.join(',');

      return this;
    }
  }, {
    key: 'orderBy',
    value: function orderBy() {
      for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      this.sorts = args;

      return this;
    }
  }, {
    key: 'page',
    value: function page(value) {
      if (!Number.isInteger(value)) {
        throw new Error('The VALUE must be an integer on page() method.');
      }

      this.pageValue = value;

      return this;
    }
  }, {
    key: 'limit',
    value: function limit(value) {
      if (!Number.isInteger(value)) {
        throw new Error('The VALUE must be an integer on limit() method.');
      }

      this.limitValue = value;

      return this;
    }
  }, {
    key: 'params',
    value: function params(payload) {
      if (payload === undefined || payload.constructor !== Object) {
        throw new Error('You must pass a payload/object as param.');
      }

      this.payload = payload;

      return this;
    }
  }]);

  return Builder;
}();

exports.default = Builder;


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-api-query/build/Builder.js
// module id = OKIF
// module chunks = 40